(() => {
  const dialogSelector = '.hpf-dialog';
  const isolatedEvents = [
    'pointerdown',
    'pointermove',
    'pointerup',
    'pointercancel',
    'touchstart',
    'touchmove',
    'touchend',
    'touchcancel',
    'wheel',
    'gesturestart',
    'gesturechange',
    'gestureend'
  ];

  const protectDialog = (dialog) => {
    if (!(dialog instanceof HTMLElement) || dialog.dataset.hpfMobileScrollFix === 'true') return;

    dialog.dataset.hpfMobileScrollFix = 'true';

    isolatedEvents.forEach((eventName) => {
      dialog.addEventListener(eventName, (event) => {
        event.stopPropagation();
      }, { passive: true });
    });
  };

  const scan = (scope = document) => {
    if (scope instanceof Element && scope.matches(dialogSelector)) protectDialog(scope);
    scope.querySelectorAll?.(dialogSelector).forEach(protectDialog);
  };

  const init = () => scan(document);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => scan(event.target));
})();

(() => {
  const esc=(s)=>String(s||'').replace(/[&<>'"]/g,(c)=>({'&':'&amp;','<':'&lt;','>':'&gt;',"'":'&#39;','"':'&quot;'}[c]));
  const text=(el)=>String(el?.textContent||'').replace(/\s+/g,' ').trim();
  const themeData=()=>typeof theme!=='undefined'?theme:(window.theme||{});
  const meta=(dialog,label)=>{
    const re=new RegExp(`^${label}:\\s*`,'i');
    const item=[...dialog.querySelectorAll('.hpf-dialog__meta span')].find((el)=>re.test(text(el)));
    return item?text(item).replace(re,''):'';
  };
  const stockType=(el)=>el?.classList.contains('hpf-stock--in')?'in':el?.classList.contains('hpf-stock--special')?'special':el?.classList.contains('hpf-stock--out')?'out':'default';

  function build(strip,index){
    if(strip.dataset.hpfBulkList==='true')return;
    const scroller=strip.querySelector('.hpf-parts-strip__scroller');
    if(!scroller)return;
    const rows=[...scroller.querySelectorAll('.hpf-part-card[data-hpf-open-dialog]')].map((card,rowIndex)=>{
      const dialogId=card.dataset.hpfOpenDialog;
      const dialog=document.getElementById(dialogId);
      if(!dialog)return null;
      const stock=dialog.querySelector('.hpf-stock');
      const submit=dialog.querySelector('.hpf-product-form__submit');
      const variantId=String(dialog.querySelector('input[name=id]')?.value||'').trim();
      return {
        rowIndex,dialogId,variantId,
        sku:meta(dialog,'SKU')||meta(dialog,'Part number')||text(card.querySelector('.hpf-part-card__code'))||'—',
        description:text(dialog.querySelector('.hpf-dialog__title'))||text(card.querySelector('.hpf-part-card__title'))||'Product details',
        availability:text(stock)||'Availability unavailable',
        type:stockType(stock),
        price:dialog.querySelector('.hpf-dialog__price')?.innerHTML||'—',
        selectable:Boolean(variantId&&submit&&!submit.disabled&&submit.getAttribute('aria-disabled')!=='true')
      };
    }).filter(Boolean);
    if(!rows.length)return;

    strip.dataset.hpfBulkList='true';
    strip.classList.add('hpf-parts-strip--list');
    const header=strip.querySelector('.hpf-parts-strip__header');
    const heading=header?.querySelector('h3');
    const intro=header?.querySelector('p');
    const total=header?.querySelector(':scope > span');
    if(heading)heading.textContent='Items matched in this diagram';
    if(intro)intro.textContent='Tick the parts you need. One of each selected item will be added to your cart.';
    if(total)total.textContent=`${rows.length} items`;

    const rowHtml=rows.map((r)=>`<tr class="${r.selectable?'':'is-unavailable'}">
      <td class="hpf-bulk-list__check"><input type="checkbox" data-hpf-item value="${esc(r.variantId)}" ${r.selectable?'':'disabled'} aria-label="${esc(r.selectable?`Select ${r.description}`:`${r.description} is unavailable`)}"></td>
      <td class="hpf-bulk-list__sku-col"><span class="hpf-bulk-list__sku">${esc(r.sku)}</span></td>
      <td class="hpf-bulk-list__description-cell"><button type="button" class="hpf-bulk-list__description" data-hpf-list-dialog="${esc(r.dialogId)}">${esc(r.description)}</button></td>
      <td class="hpf-bulk-list__availability-col"><span class="hpf-bulk-list__availability hpf-bulk-list__availability--${r.type}">${esc(r.availability)}</span></td>
      <td class="hpf-bulk-list__price-col hpf-bulk-list__price">${r.price}</td>
    </tr>`).join('');

    const list=document.createElement('div');
    list.className='hpf-bulk-list';
    list.innerHTML=`<div class="hpf-bulk-list__top"><label class="hpf-bulk-list__select-all"><input type="checkbox" data-hpf-select-all> Select all available</label></div>
      <div class="hpf-bulk-list__wrap"><table><thead><tr><th class="hpf-bulk-list__check">Select</th><th class="hpf-bulk-list__sku-col">SKU</th><th>Description</th><th class="hpf-bulk-list__availability-col">Availability</th><th class="hpf-bulk-list__price-col">Price</th></tr></thead><tbody>${rowHtml}</tbody></table></div>
      <div class="hpf-bulk-list__actions"><div class="hpf-bulk-list__count"><span data-hpf-count>0 items selected</span><small>One of each checked item will be added.</small></div><button type="button" class="btn btn--primary hpf-bulk-list__add" data-hpf-add disabled>Add selected items to cart</button><p class="hpf-bulk-list__status" data-hpf-status role="status" aria-live="polite"></p></div>`;
    scroller.replaceWith(list);

    const boxes=[...list.querySelectorAll('[data-hpf-item]')];
    const available=boxes.filter((box)=>!box.disabled);
    const selectAll=list.querySelector('[data-hpf-select-all]');
    const add=list.querySelector('[data-hpf-add]');
    const count=list.querySelector('[data-hpf-count]');
    const status=list.querySelector('[data-hpf-status]');
    const setStatus=(message,error=false,link=false)=>{
      status.classList.toggle('is-error',error);
      status.innerHTML=esc(message)+(link?` <a href="${esc(themeData().routes?.cart||'/cart')}">View cart</a>`:'');
    };
    const refresh=()=>{
      const selected=available.filter((box)=>box.checked);
      boxes.forEach((box)=>box.closest('tr')?.classList.toggle('is-selected',box.checked));
      selectAll.checked=available.length>0&&selected.length===available.length;
      selectAll.indeterminate=selected.length>0&&selected.length<available.length;
      count.textContent=`${selected.length} ${selected.length===1?'item':'items'} selected`;
      add.disabled=!selected.length;
      add.textContent=selected.length?`Add ${selected.length} selected ${selected.length===1?'item':'items'} to cart`:'Add selected items to cart';
    };

    list.addEventListener('click',(event)=>{
      const opener=event.target.closest('[data-hpf-list-dialog]');
      if(opener){
        const dialog=document.getElementById(opener.dataset.hpfListDialog);
        if(dialog?.showModal&&!dialog.open)dialog.showModal();
      }
    });
    list.addEventListener('change',(event)=>{
      if(event.target===selectAll)available.forEach((box)=>box.checked=selectAll.checked);
      refresh();
    });

    add.addEventListener('click',async()=>{
      const selected=available.filter((box)=>box.checked);
      if(!selected.length)return;
      const quantities=new Map();
      selected.forEach((box)=>quantities.set(box.value,(quantities.get(box.value)||0)+1));
      const items=[...quantities].map(([id,quantity])=>({id,quantity}));
      const settings=themeData();
      const drawer=document.querySelector('cart-drawer');
      const sections=['cart-icon-bubble','free-shipping-notice'];
      const drawerSection=drawer?.closest('.shopify-section')?.id?.replace('shopify-section-','');
      if(drawerSection)sections.push(drawerSection);
      add.disabled=true;add.classList.add('is-loading');add.setAttribute('aria-busy','true');
      setStatus(`Adding ${selected.length} ${selected.length===1?'item':'items'}…`);
      try{
        const response=await fetch(settings.routes?.cartAdd||'/cart/add.js',{method:'POST',headers:{Accept:'application/json','Content-Type':'application/json','X-Requested-With':'XMLHttpRequest'},body:JSON.stringify({items,sections:sections.join(','),sections_url:location.pathname})});
        const data=await response.json();
        if(!response.ok||data.status)throw new Error(data.description||data.message||'The selected items could not be added.');
        if(drawer?.renderContents&&data.sections)await drawer.renderContents(data,false);
        else if(data.sections?.['cart-icon-bubble']&&document.getElementById('cart-icon-bubble'))document.getElementById('cart-icon-bubble').innerHTML=data.sections['cart-icon-bubble'];
        selected.forEach((box)=>box.checked=false);
        setStatus(`${selected.length} ${selected.length===1?'item was':'items were'} added to your cart.`,false,true);
      }catch(error){setStatus(error?.message||'The selected items could not be added.',true)}
      finally{add.classList.remove('is-loading');add.removeAttribute('aria-busy');refresh()}
    });
    refresh();
  }

  const scan=(scope=document)=>scope.querySelectorAll?.('.hpf-parts-strip').forEach(build);
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>scan(),{once:true});else scan();
  document.addEventListener('shopify:section:load',(event)=>scan(event.target));
})();
